import {
  forwardRef, ReactNode,
} from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@mui/material/Box';

type TPage = {
  children: ReactNode,
  title: string
};

const Page = forwardRef(({ children, title = '', ...other }: TPage, ref) => (
  <Box ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </Box>
));

export { Page };
